<template>
	<section class="content">
		<div class="card">
			<div class="card-body">
				<div v-if="infoDownload" class="form-control bos-alert-primary lh-1 d-flex align-items-center h-100" style="margin-bottom: 15px;">
					<div class="row">
						<div class="col-auto d-flex align-items-center">
							<i class="fi fi-rr-info d-flex align-items-center"></i>
						</div>
						<div class="col d-flex align-items-center">
							<div class="text-md">
								Semua file yang Anda unduh akan tersimpan dan dapat dilihat di <a href="/data-center" class="text-info" style="text-decoration: underline;">menu data center</a>
							</div>
						</div>
					</div>
				</div>
				<div class="row mb-3" style="row-gap: .5rem;">
					<div class="col-12 col-sm-auto">
						<div class="input-group">
							<input type="text" ref="daterange" class="form-control border-right-0" style="border-right: 0" />
							<div class="input-group-append">
								<div class="input-group-text rounded-right d-flex align-items-center border-left-0 pl-1 bg-white">
									<i class="fi fi-rr-calendar d-flex"></i>
								</div>
							</div>
						</div>
					</div>
					<div class="col col-sm-auto text-right ml-auto" v-if="false">
						<div class="btn-group" ref="toolbar">
							<button type="button" data-action="read" class="btn btn-outline-primary" v-on:click="showTable">
								Show Table
							</button>
							<button type="button" :disabled="loading" v-on:click="downloadXlsx" data-action="export-xlsx" class="btn btn-primary">
								<span v-if="loading" class="spinner-border spinner-border-sm"></span>
								<i v-else class="fi fi-rr-file-excel"></i>
								Download Data
							</button>
						</div>
					</div>
				</div>

				<div class="table-responsive" :hidden="hideTable">
					<div class="btn-area mb-3" ref="btnSelected">
						<button type="button" class="btn btn-success" @click="confirmDelete(2)" :disabled="loading">
							<span v-if="loading" class="spinner-border spinner-border-sm"></span>
							<i v-else class="fi fi-rr-check"></i> Approve</button>
						<button type="button" class="btn btn-danger" @click="confirmDelete(3)" :disabled="loading">
							<span v-if="loading" class="spinner-border spinner-border-sm"></span>
							<i v-else class="fi fi-rr-cross"></i> Reject</button>
					</div>

					<table class="table table-hover w-100" ref="tableMonitoringHutangRetur" id="tableMonitoringHutangRetur">
						<thead>
							<tr>
								<th>
									<input type="radio" ref="checkall" @click="selectAllNotes" disabled />
								</th>
								<th>Pengajuan</th>
								<th>ID</th>
								<th>Shipper</th>
								<th>Alasan</th>
								<th>Status</th>
								<th>Admin</th>
								<th>Selesai</th>
							</tr>
						</thead>
						<tbody @click="handleClick"></tbody>
					</table>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import { auth, authFetch, createTable, formatRupiah } from "@/libs/hxcore";
import $ from "jquery";
import moment from "moment";
import Swal from "sweetalert2";
import "vue-select/dist/vue-select.css";
import Daterangepicker from "daterangepicker";
import "daterangepicker/daterangepicker.css";

export default {
	name: "MonitoringHutangRetur",
	data() {
		return {
			loading: false,
			hideTable: true,
			tableMonitoringHutangRetur: null,
			infoDownload: false,
			filter: {
				dt1: moment().startOf('month').format("YYYY-MM-DD"),
				dt2: moment().format("YYYY-MM-DD"),
				keyword: null,
				category: 0,
			},
			selectedCount: 0,
		};
	},
	methods: {
		formatRupiah(value) {
			return formatRupiah(value);
		},
		showTable: function () {
			// $('.loading-overlay').addClass('show');
			// if (this.dataTable) {
			// 	this.dataTable.api().ajax.reload();
			// } else {
				var self = this;
				this.dataTable = createTable(this.$refs.tableMonitoringHutangRetur, {
					roles: this.$route.params.roles,
					ajax: "/shipper/deletion_data",
					frame: false,
					toolbarEl: this.$refs.toolbar,
					fixedColumns: {
						start: 1,
						end: 1
					},
					scrollCollapse: true,
					scrollX: true,
					processing: true,
					autoWidth:false,
					language: {
						processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'
					},
					filterBy: [2, 3, 6, 4],
					order: [],
					paramData: function (d) {
						var filter = JSON.parse(JSON.stringify(self.filter));
						for (const key in filter) {
							d[key] = filter[key] === false ? 0 : filter[key];
						}
					},
					columns: [
						{
							data: "id",
							sortable: false,
							visible: auth.user().role_id == 1,
							render: function (data, type, row, meta) {
								return row.status == 1 ? `<input type="radio" name="checkrow" value="${data}" />` : "";
							}
						},
						{
							data: "request_date",
							render: function (data, type, row, meta) {
								return data ? moment(data).format("DD/MM/YYYY") : "\u2013";
							}
						},
						{
							data: "shipper_id",
							render: function (data, type, row, meta) {
								return data ? data : "\u2013";
							}
						},
						{
							data: "shipper_name",
							render: function (data, type, row, meta) {
								return data ? data : "\u2013";
							}
						},
						{
							data: "shipper_reason",
							render: function (data, type, row, meta) {
								return data ? data : "\u2013";
							}
						},
						{
							data: "status",
							render: function (data, type, row, meta) {
								var badgeClass = "dark", statusText = "\u2013";
								if (data == 1) badgeClass = "primary", statusText = "Request";
								else if (data == 2) badgeClass = "success", statusText = "Approved";
								else if (data == 3) badgeClass = "danger", statusText = "Rejected";
								return `<span class="badge bos-alert-${badgeClass} text-${badgeClass}">${statusText}</span>`;
							}
						},
						{
							data: "admin_name",
							visible: auth.user().role_id == 1,
							render: function (data, type, row, meta) {
								return row.admin_reason ? data + `<small class="d-block">${row.admin_reason}</small>` : data ? data : "\u2013";
							}
						},
						{
							data: "confirm_date",
							render: function (data, type, row, meta) {
								return data ? moment(data).format("DD/MM/YYYY") : "\u2013";
							}
						},
					],
					rowCallback: function (row, data) {
						if (data.hutang_retur < 0) { $("td:eq(5)", row).addClass("text-danger"); }
						if (data.total_credit < 0) { $("td:eq(6)", row).addClass("text-danger"); }
						if (data.total_debit < 0) { $("td:eq(7)", row).addClass("text-danger"); }
						if (data.sisa_hutang < 0) { $("td:eq(8)", row).addClass("text-danger"); }
					},
					drawCallback: function(settings) {
						self.selectedCount = 0;
						$(self.$refs.checkall).prop("checked", false);
						$(self.$refs.btnSelected).hide();
					},
					initComplete: function(settings, json) {
						self.hideTable = false;
						$('.loading-overlay').removeClass('show');
					}
				});
			// }
		},
		downloadXlsx: function (e) {
			this.loading = true;
			this.infoDownload = false;

			var filter = JSON.parse(JSON.stringify(this.filter));
				filter.keyword = $("input[name=q]").val() ? $("input[name=q]").val() : null;
				filter.category = $("select[name=category]").val() ? $("select[name=category]").val() : 0;

			var data = {
				"module_reture": 'monitoring_hutang_retur',
				"filter": filter,
				"title": 'Monitoring Hutang Retur',
				"note": JSON.stringify(filter),
			};

			const self = this;
			authFetch("/accounting/jurnal/request_download", {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			})
			.then((res) => {
				setTimeout(() => {
					self.loading = false;
				}, 1000);
				if (res){
					self.infoDownload = true;
				}
			});
		},
		handleClick(e) {
			if (e.target.matches("input[name=checkrow]")) {
				var radioboxes = document.querySelectorAll('input[name="checkrow"]:checked');
				// if (radioboxes.length != 1) {
				// 	this.$refs.checkall.checked = false;
				// } else {
				// 	this.$refs.checkall.checked = true;
				// }

				this.selectedCount = radioboxes.length;
				if (this.selectedCount == 1) {
					$(this.$refs.btnSelected).show();
				} else {
					$(this.$refs.btnSelected).hide();
				}
				return false;
			}
		},
		confirmDelete: function(action) {
			var radiobox = document.querySelector('input[name="checkrow"]:checked');
			if (!radiobox) { return false; }

			var id = radiobox.value;
			var title = action == 2 ? "Approve Penghapusan Shipper" : "Reject Penghapusan Shipper";
			var text = action == 2 ? "Anda akan menyetujui penghapusan data shipper ini. Lanjutkan?" : "Anda akan menolak penghapusan data shipper ini. Lanjutkan?";
			this.customSwal.fire({
				title: title,
				text: text,
				icon: "warning",
				showDenyButton: true,
				confirmButtonText: "Ya",
				denyButtonText: "Tidak",
			}).then((result) => {
				if (result.isConfirmed) {
					this.loading = true;
					authFetch("/shipper/confirm_deletion", {
						method: "PUT",
						headers: {
							Accept: "application/json",
							"Content-Type": "application/json",
						},
						body: JSON.stringify({ id, action }),
					})
					.then((res) => {
						if (res.status === 201) {
						} else if (res.status === 400) {
						}
						return res.json();
					})
					.then((js) => {
						this.loading = false;
						if (js.status) {
							this.dataTable.api().ajax.reload();
							Swal.fire("Berhasil", res.message, "success");
						} else {
							Swal.fire("Gagal", res.error, "error");
						}
					});
				}
			});
		},
	},
	mounted() {
		// $('.loading-overlay').removeClass('show');
		this.showTable();

		const self = this;

		new Daterangepicker(this.$refs.daterange, {
			startDate: moment().startOf('month').format("DD/MM/YYYY"),
			endDate: moment().format("DD/MM/YYYY"),
			maxDate: moment().format("DD/MM/YYYY"),
			locale: {
				format: 'DD/MM/YYYY'
			},
		}, function(d1, d2) {
			self.filter.dt1 = d1.format("YYYY-MM-DD");
			self.filter.dt2 = d2.format("YYYY-MM-DD");
			if (self.dataTable) { self.dataTable.api().ajax.reload(); }
		});

		this.customSwal = Swal.mixin({
			customClass: {
				content: 'p-0',
				title: 'h4 tex-dark',
				input: 'form-control',
				actions: 'd-flex justify-content-between flex-row-reverse',
				confirmButton: 'btn btn-primary col font-weight-bold',
				denyButton: 'btn btn-outline-primary col font-weight-bold',
				cancelButton: 'btn btn-primary w-75 font-weight-bold m-auto',
			},
			buttonsStyling: false
		});
		
		$(this.$refs.btnSelected).hide();
		$('.loading-overlay').removeClass('show');
	}
};
</script>